import React from 'react';
import { HeartPulse } from 'lucide-react';
import { useLanguage } from '../../assets/js/LanguageContext';
import GradientCard from '../common/GradientCard';
import '../../assets/styles/Common.css';
import '../../assets/styles/SectionBand.css';
import '../../assets/styles/ClosingCta.css';

const GetStartedWithLando = () => {
  const { t } = useLanguage();
  const isAuthenticated = !!localStorage.getItem('token');

  return (
    <section className="section-band">
      <div className="section-band__inner">
        <div className="closing-cta">
          <GradientCard
            accent="#7C3AED"
            badgeText={t(isAuthenticated ? 'aboutus_lando_badge_auth' : 'aboutus_lando_badge')}
            title={
              <>
                {t('aboutus_lando_title1')}{' '}
                <span className="closing-cta__highlight">{t('aboutus_lando_highlight')}</span>{' '}
                {t('aboutus_lando_title2')}
              </>
            }
            description={t(isAuthenticated ? 'aboutus_lando_text_auth' : 'aboutus_lando_text')}
            ctaText={t(isAuthenticated ? 'dashboard' : 'aboutus_lando_btn_free')}
            ctaTo={isAuthenticated ? '/dashboard' : '/sign-up'}
            icon={<HeartPulse size="1em" strokeWidth={1.25} />}
          />
        </div>
      </div>
    </section>
  );
};

export default GetStartedWithLando;
